export const rolesPermissionsFile = {
  "restricted-viewer": [
    "view-namespace",
    "view-clients",
    "view-sources",
    "view-gateways",
    "view-condition-monitoring",
    "view-dashboards",
    "apply-blueprints",
  ],
  viewer: [
    "view-namespace",
    "view-clients",
    "view-sources",
    "view-gateways",
    "view-condition-monitoring",
    "view-dashboards",
    "apply-blueprints",
    "search-blueprints",
  ],
  "system-integrator": [
    "view-namespace",
    "view-licenses",
    "view-clients",
    "view-sources",
    "view-gateways",
    "view-mqtt-config",
    "view-condition-monitoring",
    "view-dashboards",
    "apply-blueprints",
    "search-blueprints",
    "view-initial-server-nodeset",
    "view-active-nodeset",
    "manage-gateways",
    "manage-condition-monitoring",
    "manage-active-nodeset",
    "manage-sources",
    "manage-dashboards",
    "manage-blueprints",
  ],
  "dashboard-setup-manager": ["manage-blueprint-dashboards"],
  "edge-agent": ["edge-client"],
  manager: [
    "view-namespace",
    "manage-clients",
    "manage-sources",
    "manage-gateways",
    "manage-mqtt-config",
    "manage-condition-monitoring",
    "manage-dashboards",
    "view-initial-server-nodeset",
    "view-active-nodeset",
    "apply-blueprints",
    "search-blueprints",
    "manage-blueprints",
    "manage-active-nodeset",
    "view-licenses",
    "manage-licenses",
    "manage-namespace",
    "manage-timeseries",
    "view-timeseries",
  ],
  "internal-service-user-monitor": [
    "view-all-namespaces",
    "view-active-nodeset",
    "view-condition-monitoring",
    "view-sources",
  ],
  "internal-service-user-onboarding-manager": [
    "view-all-namespaces",
    "manage-gateways",
    "create-onboarding-resources",
  ],
  developer: ["view-developer-features", "view-unreleased-features"],
  "quality-assurance": ["view-unreleased-features"],
  "tt-support-user": ["manage-blueprint-dashboards"],
};
